import {createApiResource} from 'data/utils';

const resource = createApiResource({
	name: 'product',
	pathName: '/products',
	unwrap: x => x,
});

export const productQueryClientHelpers = resource.createQueryClientHelpers();

export const useProducts = resource.createUseQueryIndex();
export const useProduct = resource.createUseQueryById();
export const useCreateProduct = resource.createUseMutationCreate();
export const useUpdateProduct = resource.createUseMutationUpdate();
export const useDeleteProduct = resource.createUseMutationDelete();
